import { AxiosResponse } from "axios";
import _ from "lodash";

import API from "../../../../../../../api";

const WaybillNotificationService = {
  async getOrdersByShipmentId(shipmentId: string): Promise<AxiosResponse<any>> {
    return API.get(
      `shipment/subscriber/getPurchaseOrderByShipmentId?shipmentId=${Number(shipmentId)}`
    );
  },

  async getUsersByCompanyId(companyId: string | number): Promise<AxiosResponse<any>> {
    const include = JSON.stringify([
      {
        association: "usersCompanies",
        required: true,
        include: [{ association: "role" }],
        where: { companyId },
      },
    ]);

    return API.get(`users?Status=Active&include=${include}`);
  },

  async getSubscribers(
    shipmentId: string | number,
    page: number,
    pageSize: number,
    jobReference: string,
    searchByOr: any,
    sortBy = [["updatedAt", "desc"]]
  ): Promise<AxiosResponse<any>> {
    const mappingSort = _.isEmpty(sortBy) ? [["updatedAt", "desc"]] : sortBy;
    let paramsString = `page=${page}&pageSize=${pageSize}&sortBy=${JSON.stringify(
      mappingSort
    )}&shipmentId=${shipmentId}`;

    if (!_.isEmpty(searchByOr)) {
      paramsString += `&searchByOr=${JSON.stringify(searchByOr)}`;
    }

    if (jobReference) {
      paramsString += `&jobReference=${jobReference}`;
    }

    return API.get(`/shipment/subscriber?${paramsString}`);
  },
};

export default WaybillNotificationService;
